import Icon from '../components/Icon';

const Apple = Icon(
  'apple',
  <>
    <path d="M12.63 5.528c1.045 0 2.356-.722 3.122-1.705.707-.89 1.222-2.119 1.222-3.347 0-.169-.015-.338-.044-.476-1.163.046-2.562.798-3.387 1.812-.648.783-1.266 2.011-1.266 3.255 0 .184.03.369.044.43.074.015.191.03.31.03Zm8.496 2.656C19.58 5.85 17.224 5.79 16.576 5.79c-1.017 0-1.916.373-2.67.685-.543.226-1.011.42-1.394.42-.424 0-.908-.204-1.448-.432-.68-.287-1.447-.612-2.292-.612C5.916 5.85 3 8.338 3 12.99c0 2.918 1.075 5.973 2.4 7.954C6.55 22.618 7.55 24 8.978 24c.677 0 1.175-.224 1.699-.46.583-.261 1.2-.538 2.13-.538.918 0 1.473.257 2.01.506.505.234.996.461 1.76.461 1.545 0 2.59-1.49 3.563-2.963 1.104-1.69 1.56-3.317 1.575-3.41-.088-.03-3.063-1.289-3.063-4.851 0-2.873 2.028-4.256 2.416-4.52.03-.02.05-.033.058-.04Z" />
  </>
);

export default Apple;
